// Imports
var ___CSS_LOADER_API_IMPORT___ = require("./node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body, div, h3, p, span {\n  font-family: Raleway, sans-serif;\n}\n\nimg[src^=\"https://um.simpli.fi/lj_match?r\"] { display: none; }", ""]);
// Exports
module.exports = exports;
